import { render, staticRenderFns } from "./threshold_booleanColumn.vue?vue&type=template&id=348177f2&scoped=true&"
import script from "./threshold_booleanColumn.vue?vue&type=script&lang=js&"
export * from "./threshold_booleanColumn.vue?vue&type=script&lang=js&"
import style0 from "./threshold_booleanColumn.vue?vue&type=style&index=0&id=348177f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348177f2",
  null
  
)

export default component.exports